export interface DailyInfo {
  date: string;
  hasLocked: boolean;
  coDriverExist: boolean;
  hasViolation: boolean;
  hasDriving: boolean;
}
